const SPACE = {
  X0: '0.5rem',
  X1: '1rem',
  X2: '2rem',
  X3: '3rem',
  X4: '4rem',
} as const;

export default SPACE;
